/* unplugin-vue-components disabled */import { render } from "./DownvoteComponent.vue?vue&type=template&id=4260906d&scoped=true"
import script from "./DownvoteComponent.vue?vue&type=script&lang=js"
export * from "./DownvoteComponent.vue?vue&type=script&lang=js"

import "./DownvoteComponent.vue?vue&type=style&index=0&id=4260906d&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4260906d"]])

export default __exports__